/* import __COLOCATED_TEMPLATE__ from './category.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();